const settings = require('./settings.json');

export const BASE_URL = {
    API: process.env.REACT_APP_BASE_API,//"https://einvoicesap.azurewebsites.net/api",//process.env.REACT_APP_BASE_API,
    invoicePDF : process.env.REACT_APP_BLOB_URL//https://ppdevinv8620.blob.core.windows.net
}